'use client'
import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { EmptyMessage, GrandHeading, GrandText } from 'ui'
import { Divider, Link, VStack, Wrap, WrapItem } from '@chakra-ui/react'
import type { WidgetBlogCategory } from 'ecosystem'
import { createCn } from 'shared-utils'

interface IBlogNavigationProps {
  items: WidgetBlogCategory[]
  onSelect: (blogCategory: WidgetBlogCategory) => void
}

const cn = createCn('blog-navigation')

const BlogNavigation: FC<IBlogNavigationProps> = ({ items, onSelect }) => {
  const [selectedCategory, setSelectedCategory] = useState<WidgetBlogCategory | null>(
    items.length ? items[0] : null
  )

  useEffect(() => {
    if (selectedCategory) {
      onSelect(selectedCategory)
    }
  }, [onSelect, selectedCategory])

  if (!selectedCategory) {
    return <EmptyMessage text="No category found" />
  }

  return (
    <VStack spacing={4} w="full" className={cn()}>
      <GrandHeading
        containerProps={{ margin: 0, className: cn('title') }}
        title={selectedCategory.title.toUpperCase()}
      />
      <GrandText fontSize="sm" className={cn('description')}>
        {selectedCategory.description}
      </GrandText>
      <VStack spacing={4} w="full">
        <Divider w="full" />
        <Wrap spacing={4} w="full" className={cn('items')}>
          {items.map((item) => (
            <WrapItem key={item.id}>
              <Link
                as={GrandText}
                fontSize="md"
                fontWeight={item.id === selectedCategory.id ? 'bold' : 'normal'}
                onClick={() => {
                  setSelectedCategory(item)
                }}
                px={2}>
                {item.title.toUpperCase()}
              </Link>
            </WrapItem>
          ))}
        </Wrap>
        <Divider w="full" />
      </VStack>
    </VStack>
  )
}

export default BlogNavigation
